import * as angular from 'angular';
import { FormatAddressFilter } from './FormatAddressFilter';

let formatAddressModule = angular.module('app.areas.common.formatAddress', []);

formatAddressModule
    .filter(FormatAddressFilter.$name, FormatAddressFilter.Factory());

export default formatAddressModule.name;
